import { render, staticRenderFns } from "./recharge.vue?vue&type=template&id=70d69200&scoped=true"
import script from "./recharge.vue?vue&type=script&lang=js"
export * from "./recharge.vue?vue&type=script&lang=js"
import style0 from "./recharge.vue?vue&type=style&index=0&id=70d69200&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d69200",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d69200')) {
      api.createRecord('70d69200', component.options)
    } else {
      api.reload('70d69200', component.options)
    }
    module.hot.accept("./recharge.vue?vue&type=template&id=70d69200&scoped=true", function () {
      api.rerender('70d69200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/institutionalWalletChild/child/recharge.vue"
export default component.exports